const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfColonies extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfColonies,
            "Each civilization scores 3 culture per colony.",
            {}
        )
    }
}

module.exports = ImpactOfColonies;